import React from 'react';

function IATAModal({ IsNull, onClose }) {
    return (
        <div className={`modal ${IsNull === 'IATA' ? 'show' : ''}`}>
            {/* IATA 번호 없을때 */}
            <div className='modalWrap'>
                <p className='modal-title'>IATA코드가 검색되지 않습니다.</p>
                <br />
                <p className='modal-content'>사업자 등록 번호로 조회해 주세요.</p>
                <div>
                    <input
                        type='button'
                        className='each-button'
                        value='확인'
                        onClick={onClose}
                    ></input>
                </div>
            </div>
        </div>
    );
}

export default IATAModal;
